<!--footer section -->
<footer [class]="class">
    <section class="section-b-space light-layout">
        <div class="container">
            <div class="row footer-theme partition-f">
                <div class="col-lg-4 col-md-6">
                    <div class="footer-title footer-mobile-title">
                        <h4>about</h4>
                    </div>
                    <div class="footer-content">
                        <div class="footer-logo">
                            <img [src]="themeLogo" alt="logo">
                        </div>
                        <p>Ứng dụng giao đồ ăn được phát triển bởi Pyramide team, với nhiều tính năng dễ sử dụng, giao
                            diện thân
                            thiện với người dùng,
                            rất phù hợp với các cửa hàng kinh hoanh và các bạn sinh viên có mong muốn nâng cao thu nhập
                            của mình.
                        </p>
                        <div class="footer-social">
                            <ul>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-google-plus"
                                                                    aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)"><i class="fa fa-rss" aria-hidden="true"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col offset-xl-">
                    <div class="sub-title">
                        <!--                        <div class="footer-title">-->
                        <!--                            <h4>sản phẩm bán chạy</h4>-->
                        <!--                        </div>-->
                        <!--                        <div class="footer-contant">-->
                        <!--                            <ul>-->
                        <!--                                <li *ngFor="let product of products"><a>{{ product.name-->
                        <!--                                    }}</a></li>-->
                        <!--                            </ul>-->
                        <!--                        </div>-->
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="sub-title">
                        <a class="footer-title">
                            <h4>Chính sách và điều khoản sử dụng</h4>
                        </a>
                        <div class="footer-content">
                            <ul class="contact-list">
                                <li><i class="fa fa-file"></i>Các điều khoản về dịch vụ tại Foodify
                                </li>
                                <li><i class="fa ti-alert"></i>Chính sách về bảo mật</li>
                                <li><i class="fa fa-shield"></i><a>Chính sách về cookie</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="sub-title">
                        <div class="footer-title">
                            <h4>Thông tin ứng dụng</h4>
                        </div>
                        <div class="footer-content">
                            <ul class="contact-list">
                                <li><i class="fa fa-map-marker"></i>Foodify E-Commerce App, Đại học FPT Đà Nẵng, Việt
                                    Nam
                                </li>
                                <li><i class="fa fa-phone"></i>+84 917 806 496</li>
                                <li><i class="fa fa-envelope-o"></i><a>pyramide.developer@gmail.com</a></li>
                                <li><a href="https://nezumi-onedrive.vercel.app/api/raw/?path=/Foodify/foodify.apk"
                                       target="_blank"><img
                                        src="../../../assets/images/download.png" alt=""></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="sub-footer">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                    <div class="footer-end">
                        <p><i class="fa fa-copyright" aria-hidden="true"></i> {{ today | date:'y'}} Foodify E-Commerce
                            App /
                            Pyramide Team</p>
                    </div>
                </div>
                <div class="col-xl-6 col-md-6 col-sm-12">
                    <div class="payment-card-bottom">
                        <ul>
                            <li>
                                <a><img src="../../../assets/images/icon/zalopay.png" alt=""></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!--footer section end -->
